import React, {FC} from "react";
import {IIcon} from "../interfaces/IIcon";
import Icon from "@ant-design/icons";

const SVG: FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg"
	     width={"1em"}
	     height={"1em"}
	     fill="currentColor"
	     xmlSpace="preserve"
	     viewBox="0 0 288 288">
			<path d="m36.637 212.154-28.73 28.73 39.61 39.62 29.11-29.12c30.83 25.41 60.09 27.74 87.12 18.45l-145.49-145.49c-9.12 26.74-6.66 55.93 18.38 87.81ZM5.177 62.044c-6.42-6.42-6.42-16.83 0-23.25s16.83-6.42 23.25 0l27.22 27.22c9.99-11.21 20.7-21.87 30.85-32.03l21.7 21.69 49.46-49.45c8.33-8.34 21.98-8.34 30.32 0 8.33 8.33 8.33 21.98 0 30.31l-49.47 49.47 63.1 63.09 49.46-49.46c8.34-8.34 21.98-8.34 30.32 0s8.33 21.98 0 30.31l-49.47 49.46 22.5 22.5c-10 10-20.74 20.7-32.14 30.74l27.33 27.33c6.42 6.41 6.42 16.83 0 23.25-6.42 6.41-16.84 6.41-23.25 0z"/>
	</svg>
);

const IconDisconnect: FC<IIcon> = (props: unknown) => <Icon component={SVG} {...props} />;
export default IconDisconnect;




